<script lang="ts">
  export let height = 24
  export let width = height * 3
  export let fill = "#252525"
</script>

<svg id="dots" width="{width}px" height="{height}px" viewBox="0 0 {width} {height}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="dots" {fill}>
          <circle id="dot1" cx="{width / 2 - height * 0.7}" cy="{height / 2}" r="{height / 4}"></circle>
          <circle id="dot2" cx="{width / 2}" cy="{height / 2}" r="{height / 4}"></circle>
          <circle id="dot3" cx="{width / 2 + height * 0.7}" cy="{height / 2}" r="{height / 4}"></circle>
      </g>
  </g>
</svg>

<style>
  #dots #dot1{
    animation: load 1s infinite;
  }
  #dots #dot2{
    animation: load 1s infinite;
    animation-delay: 0.2s;
  }
  #dots #dot3{
    animation: load 1s infinite;
    animation-delay: 0.4s;
  }
  @keyframes load{
    0%{
      opacity: 0.25;
    }
    50%{
      opacity: 0.85;
    }
    100%{
      opacity: 0.25;
    }
  }
</style>
